var React = require('react');

function IconTick (props) {
    return React.createElement("svg",props,React.createElement("g",{"strokeLinejoin":"round","transform":"translate(48 8)"},[React.createElement("path",{"d":"m112 56c0 30.9-25.1 56-56 56s-56-25.1-56-56 25.1-56 56-56 56 25.1 56 56z","key":0}),React.createElement("path",{"d":"m23 56.3 17 21.2 43.3-43","key":1})]));
}

IconTick.defaultProps = {"viewBox":"0 0 208 128"};

module.exports = IconTick;

IconTick.default = IconTick;
